import axios from 'axios'

let aixoSysConfig = {
  baseURL: '',
  timeout: 1800000,
  headers: {
    'Accept': 'application/json, text/plain, */*'
  }
}

let aixoDataConfig = {
  baseURL: 'https://api.data.e-forward.cn/network',
  // baseURL: 'http://0.0.0.0:8080/network',
  timeout: 180000,
  headers: {
    'content-type': 'application/json'
  }
}

export const axiosSysApi = axios.create(aixoSysConfig)

export const axiosSysApi2 = axios.create(aixoSysConfig)

export const axiosDataApi = axios.create(aixoDataConfig)



// WEBPACK FOOTER //
// ./src/axios_init.js